import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const heroSlides = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20neon%20lit%20entertainment%20stage%20with%20dramatic%20spotlight%20beams%20and%20abstract%20silhouette%20of%20performer%20against%20deep%20black%20background%20with%20subtle%20golden%20light%20accents%2C%20cinematic%20atmosphere%2C%20professional%20editorial%20photography%20with%20high%20contrast%20and%20mysterious%20ambiance&width=1600&height=900&seq=hero-01&orientation=landscape',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20wide%20angle%20shot%20of%20luxury%20entertainment%20venue%20interior%20at%20night%20with%20elegant%20chandeliers%20and%20moody%20atmospheric%20lighting%2C%20deep%20shadows%20with%20warm%20amber%20accents%2C%20sophisticated%20editorial%20photography%20style%20with%20rich%20dark%20tones%20and%20cinematic%20composition&width=1600&height=900&seq=hero-02&orientation=landscape',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20aerial%20view%20of%20crowded%20concert%20venue%20with%20thousands%20of%20glowing%20phone%20lights%20in%20dark%20auditorium%2C%20dramatic%20stage%20spotlight%20beams%20cutting%20through%20atmospheric%20haze%2C%20professional%20event%20photography%20with%20high%20contrast%20black%20and%20gold%20color%20palette&width=1600&height=900&seq=hero-03&orientation=landscape',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const next = () => setCurrent((prev) => (prev + 1) % heroSlides.length);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-700 ${index === current ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={slide.image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
        </div>
      ))}

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 z-10 w-full">
        <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-2 drop-shadow-lg">
          {t('heroTitle1')}
        </h1>
        <h2 className="text-xl md:text-4xl lg:text-5xl font-bold font-heading text-primary-500 mb-6 drop-shadow-lg">
          {t('heroTitle2')}
        </h2>
        <p className="text-sm md:text-lg text-white/90 max-w-2xl mb-8 drop-shadow-md">
          {t('heroSubtitle')}
        </p>
        <Link
          to="/category/dujia-shoufa"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
        >
          {t('heroCta')}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <button
        type="button"
        onClick={prevSlide}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/50 text-foreground-950 hover:bg-background-50/80 transition-colors z-10 cursor-pointer"
        aria-label="Previous slide"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      <button
        type="button"
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/50 text-foreground-950 hover:bg-background-50/80 transition-colors z-10 cursor-pointer"
        aria-label="Next slide"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${index === current ? 'bg-primary-500' : 'bg-foreground-900/50'}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}